import loadable from '@loadable/component';
import React from 'react';

import {
  UserReviewSummary,
  PageInfo,
  GenericUserReviewFragment,
  AdvizedTest,
} from '../../../../types';
import { BelongsTo } from '../../../../components/user-review-card/types';

type Props = {
  belongsTo: BelongsTo;
  myReview?: GenericUserReviewFragment | null;
  summary?: UserReviewSummary;
  nodes?: (GenericUserReviewFragment | null)[] | null;
  pageInfo?: PageInfo | null;
  showNewReviewLayout?: boolean;
  showAds?: boolean;
  expertReview?: AdvizedTest;
};

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "reviews" */ '../../../reviews')
);

const UserReviewsLoader = (props: Props) => {
  // Data not loaded
  if (!props.pageInfo) {
    return null;
  }

  return <LoadableComponent {...props} />;
};

export default UserReviewsLoader;
